export enum FileExtensionEnum {
  EXCEL = "xlsx",
  PDF = "pdf"
}